/**
 * /frontend/src/features/analytics/components/customers/NewVsReturningTrendChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import TrendLineChart from '../charts/TrendLineChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * New vs returning customers trend.
 * @param {{data:Array<{label:string,newCustomers:number,returningCustomers:number}>}} props
 * @returns {JSX.Element}
 */
const NewVsReturningTrendChart = ({ data }) => {
  const lines = useMemo(() => ([
    { key: 'newCustomers', label: 'New', color: CHART_COLORS.accent },
    { key: 'returningCustomers', label: 'Returning', color: CHART_COLORS.success }
  ]), []);

  return (
    <ChartContainer title="New vs Returning" subtitle="Customer counts over time">
      <TrendLineChart data={data} xKey="label" lines={lines} />
    </ChartContainer>
  );
};

export default NewVsReturningTrendChart;

